import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import AuthApi from "../../../service/AuthApi";
import { pushNotification } from "../../../utils/notifications";
import { setToken, getToken } from "utils/cookieExtension";
import { setTokenGlobal, setBaseURL, setTokenBase } from "service/common";
import twofactorApi from "service/twofactorApi";
import OtpInput from "react-otp-input";
import { Cookies } from "react-cookie";

export const ModalXacThucBaoMat2Lop = (props) => {
  const componentRef = useRef();
  const [data, setData] = useState({});
  useEffect(() => {
    setData(props.data);
  }, []);
  const SetThongTinLogin = (token) => {
    setToken("userInfo", "token=" + token);
    setToken("tokenMorman", token);
    setTokenBase(token, window.endPoint);
  };
  // const XacThucDangNhap = async () => {
  //   debugger;
  //   if (typeof data.MaXacThuc === "undefined" || data.MaXacThuc.length < 6) {
  //     pushNotification(
  //       "Vui lòng nhập đúng mã xác thực.",
  //       "error",
  //       "TOP_CENTER",
  //       3000
  //     );
  //   }
  //   const response = await AuthApi.login(data);
  //   debugger;
  //   if (response && response.status === 200) {
  //     SetThongTinLogin(response.data.token);
  //     setTimeout(() => {
  //       window.location.href = "/trang-chu.aspx";
  //     }, 2000);
  //   } else {
  //     const errorMessage =
  //       response?.data?.message ||
  //       response?.data ||
  //       "Đăng nhập thất bại. Vui lòng thử lại hoặc liên hệ hỗ trợ.";
  //     pushNotification(errorMessage, "error", "TOP_CENTER", 3000);
  //   }
  // };


    const cookies = new Cookies();
    let userName = cookies.get("userInfo1");
    userName = userName?.replace("username=", "");

  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const verify = () => {
    if (!otp) {
      pushNotification("Vui lòng nhập mã otp", "error", "TOP_CENTER", 2000);
      return;
    }
    const payload = {
      otp: otp,
      userName: userName,
    };

    setLoading(true);

    twofactorApi
      .verifyOtp(payload)
      .then((response) => {
        if (response && response.data) {
          setLoading(false);
          const isSuccess = response.data.isSuccess;
          const message = response.data.message;
          if (!isSuccess) {
            pushNotification(message, "error", "TOP_CENTER", 2000);
            return;
          }

          SetThongTinLogin(response.data.token);
          window.location.href = response.data.RedirectUrl;
        } else {
          pushNotification(
            "Đã có lỗi xảy ra, hãy thử lại sau",
            "error",
            "TOP_CENTER",
            2000
          );
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const sendMail = () => {
    setLoading(true);
    twofactorApi
      .sendQr(userName)
      .then((response) => {
        setLoading(false);
        if (response.data === true) {
          pushNotification(
            "Đã gửi mã QR đến mail của bạn",
            "success",
            "TOP_CENTER",
            2000
          );
        } else {
          pushNotification(
            "Đã có lỗi trong quá trình xử lý, hãy thử lại sau",
            "error",
            "TOP_CENTER",
            2000
          );
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      {...props}
      size="modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="fade modal-new modal fade text-left modal show"
      backdrop="static"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-qrcode"></i>
          </span>
          Xác thực bảo mật
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="row text-center">
          <div className="col-sm-12 col-lg-12 col-12">
            <div style={{ width: "100%" }}>
              <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                renderSeparator={<span>&#160;</span>}
                renderInput={(props) => <input {...props} />}
                inputStyle={{ width: "50px", height: "50px" }}
                containerStyle = {{justifyContent:"center"}}
              />
            </div>
            <div style={{ width: "300px", textAlign: "right" }}>
              <a href="#" onClick={sendMail} disabled={loading}>
                Gửi lại QR? 
              </a>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer">
        <button
          type="button"
          class="btn btn-new-main btn-closenew"
          href={() => false}
          onClick={props.onHide}
        >
          <span>
            <i class="mdi mdi-close"></i>
          </span>
          &nbsp; Đóng &nbsp;
        </button>
        <button
          className="btn btn-new-main btn-checknew"
          style={{ width: "200px" }}
          onClick={verify}
          disabled={loading}
        >
          Nhập
        </button>
      </Modal.Footer>
    </Modal>
  );
};
